import { MEDIA_BASE_URL } from "../api/auth";

// Helper to get the full image URL
export const getProductImageUrl = (input: string | { image_url: string }): string => {
    if (!input) return '';
    const url = typeof input === 'string' ? input : input.image_url;
    if (!url) return '';
    if (url.startsWith('/media/')) {
        return `${MEDIA_BASE_URL}/${url}`;
    }
    return url;
};